// extracted by mini-css-extract-plugin
module.exports = {"button":"AddButton_button__yxKhv","badge":"AddButton_badge__8Yich"};